import { combineReducers } from "redux";

import dashboardActions from "../constants/dashboardActions";
import {
  getFetchingState,
  getSuccessState,
  getErrorState,
  getResetState,
  createReducer,
} from "../utils/reducers";

const defaultState = {
  fetching: false,
  error: null,
  result: null,
};

export const getDashboardOverviewReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OVERVIEW]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_CLEAR]: getResetState,
});

export const getDashboardIncomingOverviewReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_CLEAR]: getResetState,
});

export const getDashboardOverviewBagReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OVERVIEW_BAG]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_BAG_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_BAG_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OVERVIEW_BAG_CLEAR]: getResetState,
});

export const getDashboardIncomingOverviewBagReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_CLEAR]: getResetState,
});

export const getDashboardIncomingBagsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardOutscanBagsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardOutscanToCpShipmentsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardOutscanToCpBagsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardInscanShipmentsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardOutscanShipmentsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardIncomingShipmentsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_CLEAR]: getResetState,
});

export const getDashboardInscanBagsClickableReducer = createReducer(defaultState, {
  [dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE]: getFetchingState,
  [dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_SUCCESS]: getSuccessState,
  [dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_ERROR]: getErrorState,
  [dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_CLEAR]: getResetState,
});

export default combineReducers({
  getDashboardOverviewReducer,
  getDashboardIncomingOverviewReducer,
  getDashboardOverviewBagReducer,
  getDashboardIncomingOverviewBagReducer,
  getDashboardIncomingBagsClickableReducer,
  getDashboardOutscanBagsClickableReducer,
  getDashboardOutscanToCpShipmentsClickableReducer,
  getDashboardOutscanToCpBagsClickableReducer,
  getDashboardInscanShipmentsClickableReducer,
  getDashboardOutscanShipmentsClickableReducer,
  getDashboardIncomingShipmentsClickableReducer,
  getDashboardInscanBagsClickableReducer,
});
